import { useState, useCallback } from 'react';
import '../../Atoms/Button/Button.js';
import '../../Atoms/Checkbox/Checkbox.js';
import './../../../../ext/react/jsx-runtime.js';
import 'clsx';
import '../../Atoms/Text/Text.js';
import '../../Atoms/Device/DeviceProvider.js';
import '../../Atoms/EmployeeBadge/EmployeeBadge.js';
import '../../Atoms/FeatureFlag/FeatureFlag.js';
import 'wretch';
import 'wretch/addons/queryString';
import '../../../utils/mParticle/mParticle.js';
import 'fromentries';
import '../../Atoms/Icon/generated/IconAdd.js';
import '../../Atoms/Icon/generated/IconAddFilled.js';
import '../../Atoms/Icon/generated/IconAddOutline.js';
import '../../Atoms/Icon/generated/IconAddUser.js';
import '../../Atoms/Icon/generated/IconAddressBook.js';
import '../../Atoms/Icon/generated/IconAllTreatments.js';
import '../../Atoms/Icon/generated/IconArrowBack.js';
import '../../Atoms/Icon/generated/IconArrowForward.js';
import '../../Atoms/Icon/generated/IconBadgeCheck.js';
import '../../Atoms/Icon/generated/IconBeard.js';
import '../../Atoms/Icon/generated/IconBody.js';
import '../../Atoms/Icon/generated/IconCake.js';
import '../../Atoms/Icon/generated/IconCalendar.js';
import '../../Atoms/Icon/generated/IconCalendarAdd.js';
import '../../Atoms/Icon/generated/IconCalendarDelete.js';
import '../../Atoms/Icon/generated/IconCard.js';
import '../../Atoms/Icon/generated/IconCash.js';
import '../../Atoms/Icon/generated/IconCaution.js';
import '../../Atoms/Icon/generated/IconChat.js';
import '../../Atoms/Icon/generated/IconCheckFilled.js';
import '../../Atoms/Icon/generated/IconCheckOutline.js';
import '../../Atoms/Icon/generated/IconChecked.js';
import '../../Atoms/Icon/generated/IconChevronDown.js';
import '../../Atoms/Icon/generated/IconChevronLeft.js';
import '../../Atoms/Icon/generated/IconChevronLeftOutline.js';
import '../../Atoms/Icon/generated/IconChevronRight.js';
import '../../Atoms/Icon/generated/IconChevronRightOutline.js';
import '../../Atoms/Icon/generated/IconChevronUp.js';
import '../../Atoms/Icon/generated/IconClose.js';
import '../../Atoms/Icon/generated/IconCloseOutline.js';
import '../../Atoms/Icon/generated/IconComment.js';
import '../../Atoms/Icon/generated/IconCompass.js';
import '../../Atoms/Icon/generated/IconConfirmOrDeny.js';
import '../../Atoms/Icon/generated/IconCopy.js';
import '../../Atoms/Icon/generated/IconDiscountFilled.js';
import '../../Atoms/Icon/generated/IconDiscountOutline.js';
import '../../Atoms/Icon/generated/IconEdit.js';
import '../../Atoms/Icon/generated/IconEmail.js';
import '../../Atoms/Icon/generated/IconExpand.js';
import '../../Atoms/Icon/generated/IconExternal.js';
import '../../Atoms/Icon/generated/IconFace.js';
import '../../Atoms/Icon/generated/IconFilter.js';
import '../../Atoms/Icon/generated/IconGift.js';
import '../../Atoms/Icon/generated/IconHair.js';
import '../../Atoms/Icon/generated/IconHairRemoval.js';
import '../../Atoms/Icon/generated/IconHappy.js';
import '../../Atoms/Icon/generated/IconHeartFilled.js';
import '../../Atoms/Icon/generated/IconHeartOutlined.js';
import '../../Atoms/Icon/generated/IconHelp.js';
import '../../Atoms/Icon/generated/IconHide.js';
import '../../Atoms/Icon/generated/IconHighlights.js';
import '../../Atoms/Icon/generated/IconHome.js';
import '../../Atoms/Icon/generated/IconHomebasedVenue.js';
import '../../Atoms/Icon/generated/IconImage.js';
import '../../Atoms/Icon/generated/IconInfoOutline.js';
import '../../Atoms/Icon/generated/IconLegal.js';
import '../../Atoms/Icon/generated/IconLocation.js';
import '../../Atoms/Icon/generated/IconLock.js';
import '../../Atoms/Icon/generated/IconLogOut.js';
import '../../Atoms/Icon/generated/IconMale.js';
import '../../Atoms/Icon/generated/IconMassage.js';
import '../../Atoms/Icon/generated/IconMedicalDental.js';
import '../../Atoms/Icon/generated/IconMinusOutline.js';
import '../../Atoms/Icon/generated/IconMobileVenue.js';
import '../../Atoms/Icon/generated/IconMoney.js';
import '../../Atoms/Icon/generated/IconNails.js';
import '../../Atoms/Icon/generated/IconNewVenue.js';
import '../../Atoms/Icon/generated/IconNotes.js';
import '../../Atoms/Icon/generated/IconOnMap.js';
import '../../Atoms/Icon/generated/IconOptions.js';
import '../../Atoms/Icon/generated/IconPhone.js';
import '../../Atoms/Icon/generated/IconPin.js';
import '../../Atoms/Icon/generated/IconPinOutline.js';
import '../../Atoms/Icon/generated/IconPresentBox.js';
import '../../Atoms/Icon/generated/IconProfile.js';
import '../../Atoms/Icon/generated/IconReceipt.js';
import '../../Atoms/Icon/generated/IconSearch.js';
import '../../Atoms/Icon/generated/IconSecure.js';
import '../../Atoms/Icon/generated/IconSettings.js';
import '../../Atoms/Icon/generated/IconSort.js';
import '../../Atoms/Icon/generated/IconSpa.js';
import '../../Atoms/Icon/generated/IconStarFilled.js';
import '../../Atoms/Icon/generated/IconStarOutline.js';
import '../../Atoms/Icon/generated/IconSupport.js';
import '../../Atoms/Icon/generated/IconTeam.js';
import '../../Atoms/Icon/generated/IconTime.js';
import '../../Atoms/Icon/generated/IconTreatwellLogo.js';
import '../../Atoms/Icon/generated/IconUnisex.js';
import '../../Atoms/Icon/generated/IconUser.js';
import '../../Atoms/Icon/generated/IconUserDetails.js';
import '../../Atoms/Icon/generated/IconVenue.js';
import '../../Atoms/Icon/generated/IconView.js';
import '../../Atoms/Icon/generated/IconVoucher.js';
import '../../Atoms/Icon/generated/IconWallet.js';
import '../../Atoms/Icon/generated/IconWarningFilled.js';
import '../../Atoms/Icon/generated/IconWarningOutline.js';
import '../../Atoms/Icon/generated/IconWebsite.js';
import '../../Atoms/IconBadge/IconBadge.js';
import '../../Atoms/Input/Input.js';
import '../../Layout/Box/Box.js';
import '../../Layout/Inline/Inline.js';
import '../../Layout/Stack/Stack.js';
import '../../Atoms/Radio/Radio.js';
import '@treatwell/design-tokens';
import '../../Atoms/VisuallyHidden/VisuallyHidden.js';
import '../../Atoms/Textarea/Textarea.js';
import '../../Atoms/TreatmentTypeBadge/TreatmentTypeBadge.js';
import { useViewport } from '../../Atoms/Viewport/useViewport.js';
import '../../Atoms/LinkButton/LinkButton.js';
import { useWindowHeight } from '../../../hooks/useWindowHeight/useWindowHeight.js';

const useModal = ({ title, onToggle, preventDismiss, width, height, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [triggerRef, setTriggerRef] = useState(null);
    const handleModalOpen = useCallback(() => {
        setIsOpen(true);
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(true);
    }, [onToggle]);
    const handleModalClose = useCallback(() => {
        setIsOpen(false);
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(false);
        triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.focus();
    }, [onToggle, triggerRef]);
    const isMobile = useViewport({ device: 'mobile' });
    const windowHeight = useWindowHeight();
    const contentWidth = width ? width : undefined;
    const contentHeight = height ? height : 'var(--Modal-desktop-height)';
    const style = {
        width: isMobile ? undefined : contentWidth,
        height: isMobile ? windowHeight : contentHeight,
    };
    const modalProps = {
        title,
        isOpen,
        preventDismiss,
        onClose: handleModalClose,
        style,
    };
    return {
        isOpen,
        openModal: handleModalOpen,
        closeModal: handleModalClose,
        setTriggerRef,
        modalProps,
    };
};

export { useModal };
//# sourceMappingURL=useModal.js.map
